import { Component } from '@angular/core';
import { TextAutoCompleteComponent } from '../../../../../../coverpath-common/angular/components/application-form/base-components/text-autocomplete/text-autocomplete.component';

@Component({
  moduleId: module.id,
  selector: 'text-autocomplete-dropdown',
  host: {
    '(document:click)': 'handleClick($event)',
  },
  templateUrl: '../text-autocomplete/text-autocomplete.component.html',
})
export class TextAutoCompleteDropDownComponent extends TextAutoCompleteComponent {
  isSelect: boolean = true;

  filter() {
    let searchTerm = this.query.listValue;
    if (searchTerm !== '') {
      searchTerm = searchTerm.toLowerCase();
      this.filteredList = this.options.filter((option) => {
        // include option in filteredList if it's listValue begins with searchTerm (case insensitive)
        const optionListValueLower: string = option.listValue.toLowerCase();
        return optionListValueLower.substring(0, searchTerm.length) === searchTerm;
      });
    } else {
      this.filteredList = this.options;
    }
  }

  handleClick(event) {
    let inside = false;
    let clickedComponent = event.target;
    while (clickedComponent) {
      if (clickedComponent === this.elementRef.nativeElement) {
        inside = true;
      }
      clickedComponent = clickedComponent.parentNode;
    }
    if (!inside) {
      this.filteredList = [];
    } else if (!this.isDisabled && !this.disableConditionally) {
      this.filteredList = this.options;
    }
  }
}
